import "@common/jquery-ext";
import Cookies from "js-cookie";
import {ajax} from "@common/ajax";
import {menu} from "@common/menu";

const mCookieName = "remember-id";
$(() => {
    // events
    $("#userId").enter("#userPw");
    $("#userPw").enter(doLogin);
    $("#btnLogin").on("click", doLogin);

    // cookie
    const userId = Cookies.get(mCookieName);
    if (!!userId) {
        $("#userId").val(userId);
        $("#rememberId").setCheck(true);
        $("#userPw").setFocus();
    }
    else {
        $("#userId").setFocus();
    }
});

const doLogin = () => {
    // hide message
    hideMessage();

    // check valid
    if ($("#userId").val() === "") {
        showMessage("아이디를 입력해주세요.");
        $("#userId").setFocus();
    }
    else if ($("#userPw").val() === "") {
        showMessage("비밀번호를 입력해주세요.");
        $("#userPw").setFocus();
    }
    else {
        if ($("#rememberId").isCheck()) {
            const userId = $("#userId").val();
            Cookies.set(mCookieName, `${userId}`, { expires: 604800 });
        }
        else {
            Cookies.remove(mCookieName);
        }

        ajax.submit({
            url: "./loginProc.do",
            form: "#frmLogin",
            callback: {
                success: (result: any) => {
                    !!result.returnUrl ? menu.go(result.returnUrl, true) : menu.goHomeReplace();
                },
                error: (result: any) => {
                    showMessage(result.message);
                }
            },
            messages: [
                { code: 1, message: "사용자 정보를 찾을 수 없습니다." },
                { code: 2, message: "아이디 또는 비밀번호를 잘못 입력했습니다." },
                { code: 3, message: "사용할 수 없는 계정입니다." }
            ]
        });
    }
}

const showMessage = (message: string): void => {
    $(".account-message").html(message).show();
}

const hideMessage = (): void => {
    $(".account-message").html("");
}